exports.install =  (Vue, options) => {
	Vue.prototype.lang = (key) => {
		const library = {
			back: '返回',
			proxy_title: '渠道中心',
			resource_title: '资源中心'
		}
		if (library.hasOwnProperty(key)) {
			return library[key]
		} else {
			return key
		}
	}
}


// WEBPACK FOOTER //
// ./src/utils/zh-cn.js